import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL, apiUrl } from '../config/api';

// Componentă Stații de lucru – actualizat pentru ca Admin să poată edita/șterge orice înregistrare
const StatiiLucru = ({ statiiLucru, setStatiiLucru, currentUser, currentUserRole }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingStatie, setEditingStatie] = useState(null);
  const [denumire, setDenumire] = useState('');
  const [intervalFunc, setIntervalFunc] = useState('');
  const [sfarsit, setSfarsit] = useState('');
  const [repaus, setRepaus] = useState('');
  const [repausSfarsit, setRepausSfarsit] = useState('');
  const weekDayOptions = [
    { key: 'Lun', label: 'Luni' },
    { key: 'Mar', label: 'Marți' },
    { key: 'Mie', label: 'Miercuri' },
    { key: 'Joi', label: 'Joi' },
    { key: 'Vin', label: 'Vineri' },
    { key: 'Sam', label: 'Sâmbătă' },
    { key: 'Dum', label: 'Duminică' }
  ];
  const [workingDays, setWorkingDays] = useState([]); // array of keys
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [importing, setImporting] = useState(false);
  const [ture, setTure] = useState([]);
  const [selectedTura, setSelectedTura] = useState('AB');
  const [assignedTura, setAssignedTura] = useState(null); // assigned shift for the workstation being edited/created
  const [newTuraName, setNewTuraName] = useState('');
  const [newTuraColor, setNewTuraColor] = useState('#ffffff');
  // Roluri
  // Tratăm atât 'Admin' cât și 'Administrator' ca rol de administrator
  const isAdmin = currentUserRole === 'Admin' || currentUserRole === 'Administrator';
  // Operator role helper
  const isOperator = currentUserRole === 'Operatori' || currentUserRole === 'Operator';

  // Filter states
  const [filters, setFilters] = useState({
    denumire: ''
  });

  // Sort states
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'default'
  });

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [inputValue, setInputValue] = useState('25');

  // Rename modal states
  const [renameModalOpen, setRenameModalOpen] = useState(false);
  const [renameOldName, setRenameOldName] = useState('');
  const [renameNewName, setRenameNewName] = useState('');
  const [renameColor, setRenameColor] = useState('');

  useEffect(() => {
    fetchStatiiLucru();
    fetchTure();
  }, []);

  const fetchStatiiLucru = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/statii-lucru`);
      // Normalizăm workingDays ca array
      const norm = response.data.map(s => ({
        ...s,
        workingDays: Array.isArray(s.workingDays) ? s.workingDays : (typeof s.workingDays === 'string' ? s.workingDays.split(',').filter(Boolean) : [])
      }));
      setStatiiLucru(norm);
    } catch (error) {
      console.error('Error fetching statii lucru:', error);
      setError('Eroare la încărcarea stațiilor de lucru');
    }
  };

  const fetchTure = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/ture`);
      const list = Array.isArray(res.data) ? res.data : [];
      setTure(list);
      if (list && list.length > 0) {
        const first = list[0];
        setSelectedTura(typeof first === 'string' ? first : (first.name || 'AB'));
      }
    } catch(e) { console.error('Error fetching shifts', e); }
  };

  // CSV Import/Export Functions for Statii
  const handleCSVImport = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setImporting(true);
    setError('');

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const csv = e.target.result;
        const lines = csv.split('\n').filter(line => line.trim());
        if (lines.length < 2) {
          throw new Error('Fișierul CSV trebuie să conțină cel puțin o linie de header și o linie de date');
        }

        const headers = lines[0].split(',').map(h => h.trim().toLowerCase());
        if (!headers.includes('denumire')) {
          throw new Error('Fișierul CSV trebuie să conțină coloana "denumire"');
        }

        const newStatii = [];
        for (let i = 1; i < lines.length; i++) {
          const values = lines[i].split(',').map(v => v.trim());
          if (values.length >= headers.length && values[0]) {
            const statieData = {
              denumire: values[headers.indexOf('denumire')],
              intervalFunc: headers.includes('intervalfunc') ? values[headers.indexOf('intervalfunc')] || '' : '',
              sfarsit: headers.includes('sfarsit') ? values[headers.indexOf('sfarsit')] || '' : '',
              repaus: headers.includes('repaus') ? values[headers.indexOf('repaus')] || '' : '',
              repausSfarsit: headers.includes('repaussfarsit') ? values[headers.indexOf('repaussfarsit')] || '' : '',
              createdBy: currentUser?.username
            };

            try {
              const response = await axios.post(`${API_BASE_URL}/statii-lucru`, statieData);
              newStatii.push(response.data);
            } catch (apiError) {
              console.error(`Error adding statie ${statieData.denumire}:`, apiError);
            }
          }
        }

        setStatiiLucru(prev => [...prev, ...newStatii]);
        setError(`Import realizat cu succes! Au fost adăugate ${newStatii.length} stații de lucru.`);
      } catch (error) {
        console.error('CSV import error:', error);
        setError(error.message || 'Eroare la importarea fișierului CSV');
      } finally {
        setImporting(false);
        event.target.value = '';
      }
    };

    reader.onerror = () => {
      setError('Eroare la citirea fișierului');
      setImporting(false);
      event.target.value = '';
    };

    reader.readAsText(file);
  };

  const triggerFileInput = () => {
    document.getElementById('csv-file-input-statii').click();
  };

  const exportToCSV = () => {
    const filteredData = getFilteredAndSortedStatii();
    if (filteredData.length === 0) {
      setError('Nu există date pentru export');
      return;
    }

    const headers = ['denumire', 'intervalFunc', 'sfarsit', 'repaus', 'repausSfarsit', 'createdBy'];
    const csvContent = [
      headers.join(','),
      ...filteredData.map(statie => headers.map(header => statie[header] || '').join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `statii_lucru_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setError('Export realizat cu succes!');
    }
  };

  // Handlers for adding and deleting ture (shifts)
  const handleAddTura = async () => {
    const name = (newTuraName || '').trim();
    if (!name) {
      setError('Numele turei este obligatoriu');
      return;
    }
    if (ture.includes(name)) {
      setError('Tura există deja');
      return;
    }

    try {
      setLoading(true);
      setError('');
      await axios.post(`${API_BASE_URL}/ture`, { name, color: newTuraColor, currentUser: currentUser?.username });
      await fetchTure();
      setNewTuraName('');
      setNewTuraColor('#ffffff');
      setError('Tura creată cu succes');
    } catch (err) {
      console.error('Error creating tura:', err);
      setError(err.response?.data?.error || 'Eroare la crearea turei');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTura = async (tName) => {
    if (!tName) return;
    if (tName === 'AB') {
      setError('Nu puteți șterge tura AB');
      return;
    }
    if (!window.confirm(`Sigur doriți să ștergeți tura "${tName}"? Acțiunea va elimina setarea din toate stațiile.`)) return;

    try {
      setLoading(true);
      setError('');
      await axios.delete(`${API_BASE_URL}/ture/${encodeURIComponent(tName)}`, { data: { currentUser: currentUser?.username } });
      await fetchTure();
      if (selectedTura === tName) setSelectedTura('AB');
      setError('Tura ștearsă cu succes');
    } catch (err) {
      console.error('Error deleting tura:', err);
      setError(err.response?.data?.error || 'Eroare la ștergerea turei');
    } finally {
      setLoading(false);
    }
  };

  // Rename a tura: copy values under oldName to newName across all stations, then refresh
  const handleRenameTura = async (oldName) => {
    const newName = window.prompt('Introduceți noul nume pentru tura', oldName);
    if (!newName) return;
    const name = newName.trim();
    if (!name) { setError('Numele turei nu poate fi gol'); return; }
    if (ture.includes(name)) { setError('Există deja o tură cu acest nume'); return; }

    if (!window.confirm(`Doriți să redenumiți tura "${oldName}" în "${name}"?`)) return;

    try {
      setLoading(true);
      setError('');
      // perform update per station to move the key
      const updatedPromises = statiiLucru.map(async (statie) => {
        const currentTure = statie.ture && typeof statie.ture === 'object' ? { ...statie.ture } : {};
        if (currentTure[oldName]) {
          currentTure[name] = currentTure[oldName];
          delete currentTure[oldName];

          // send update to backend
          const payload = {
            denumire: statie.denumire,
            intervalFunc: statie.intervalFunc || '',
            sfarsit: statie.sfarsit || '',
            repaus: statie.repaus || '',
            repausSfarsit: statie.repausSfarsit || '',
            workingDays: statie.workingDays || [],
            ture: currentTure,
            currentUser: currentUser?.username
          };

          try {
            await axios.put(`${API_BASE_URL}/statii-lucru/${statie.id}`, payload);
          } catch (err) {
            console.error(`Failed updating statie ${statie.id} during rename:`, err);
          }
        }
      });

      await Promise.all(updatedPromises);
      await fetchTure();
      await fetchStatiiLucru();
      setError('Tura redenumită cu succes');
    } catch (err) {
      console.error('Error renaming tura:', err);
      setError('Eroare la redenumirea turei');
    } finally {
      setLoading(false);
    }
  };

  // When selectedTura changes while editing, update modal fields to show that tura's values
  useEffect(() => {
    if (showModal && editingStatie) {
      const st = statiiLucru.find(s => s.id === editingStatie.id);
      if (st) {
        const shift = st.ture && st.ture[selectedTura] ? st.ture[selectedTura] : null;
        setIntervalFunc(shift?.intervalFunc || st.intervalFunc || '');
        setSfarsit(shift?.sfarsit || st.sfarsit || '');
        setRepaus(shift?.repaus || st.repaus || '');
        setRepausSfarsit(shift?.repausSfarsit || st.repausSfarsit || '');
      }
    }
  }, [selectedTura]);

  // Filter function
  const handleFilterChange = (column, value) => {
    setFilters(prev => ({
      ...prev,
      [column]: value
    }));
    setCurrentPage(1); // Reset to first page when filtering
  };

  // Sort function
  const handleSort = (column) => {
    setSortConfig(prevConfig => {
      const direction = prevConfig.key === column && prevConfig.direction === 'asc' 
        ? 'desc' 
        : prevConfig.key === column && prevConfig.direction === 'desc'
          ? 'default'
          : 'asc';
      
      return { key: column, direction };
    });
  };

  const getSortIcon = (column) => {
    if (sortConfig.key !== column) return '↕️';
    if (sortConfig.direction === 'asc') return '🔼';
    if (sortConfig.direction === 'desc') return '🔽';
    return '↕️';
  };

  // Filter and sort functions
  const getFilteredAndSortedStatii = () => {
    let filtered = statiiLucru.filter(statie => {
      return statie.denumire.toLowerCase().includes(filters.denumire.toLowerCase());
    });

    if (sortConfig.key && sortConfig.direction !== 'default') {
      filtered.sort((a, b) => {
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];
        
        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    return filtered;
  };

  // Pagination functions
  const getTotalPages = () => {
    return Math.ceil(getFilteredAndSortedStatii().length / itemsPerPage);
  };

  const getPaginatedStatii = () => {
    const filtered = getFilteredAndSortedStatii();
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filtered.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= getTotalPages()) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setInputValue(newItemsPerPage.toString());
    setCurrentPage(1);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    
    const numValue = parseInt(value);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 1000) {
      setItemsPerPage(numValue);
      setCurrentPage(1);
    }
  };

  const handleAddStatie = () => {
    setEditingStatie(null);
    setDenumire('');
    setIntervalFunc('');
    setSfarsit('');
    setRepaus('');
    setRepausSfarsit('');
    setWorkingDays(['Lun','Mar','Mie','Joi','Vin']);
    // default assign current selectedTura (or first available)
    setAssignedTura(selectedTura || (ture.length>0 ? ture[0] : null));
    setShowModal(true);
    setError('');
  };

  const handleEditStatie = (statie) => {
    if (isOperator) { setError('Operatorii nu pot edita stații de lucru'); return; }
    setEditingStatie(statie);
    // preferăm valorile pentru tura selectată dacă există
    const shift = statie.ture && statie.ture[selectedTura] ? statie.ture[selectedTura] : null;
    setDenumire(statie.denumire);
    setIntervalFunc(shift?.intervalFunc || statie.intervalFunc || '');
    setSfarsit(shift?.sfarsit || statie.sfarsit || '');
    setRepaus(shift?.repaus || statie.repaus || '');
    setRepausSfarsit(shift?.repausSfarsit || statie.repausSfarsit || '');
    setWorkingDays(statie.workingDays && statie.workingDays.length ? statie.workingDays : ['Lun','Mar','Mie','Joi','Vin']);
    // assigned shift for this station
    setAssignedTura(statie.tura || selectedTura || (ture.length>0 ? ture[0] : null));
    setShowModal(true);
    setError('');
  };

  const handleDeleteStatie = async (statie) => {
    if (isOperator) { setError('Operatorii nu pot șterge stații de lucru'); return; }
    if (window.confirm(`Sigur doriți să ștergeți stația de lucru "${statie.denumire}"?`)) {
      try {
        setLoading(true);
        await axios.delete(`${API_BASE_URL}/statii-lucru/${statie.id}`, {
          data: { currentUser: currentUser?.username }
        });
        setStatiiLucru(statiiLucru.filter(s => s.id !== statie.id));
        setError('');
      } catch (error) {
        console.error('Error deleting statie:', error);
        setError(error.response?.data?.error || 'Eroare la ștergerea stației de lucru');
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSave = async () => {
    if (!denumire.trim()) {
      setError('Denumirea stației de lucru este obligatorie');
      return;
    }

    try {
      setLoading(true);
      setError('');

      // Build tura object for this station based on selectedTura
      if (editingStatie) {
        const existing = { ...(editingStatie.ture && typeof editingStatie.ture === 'object' ? editingStatie.ture : {}) };
        existing[selectedTura] = {
          intervalFunc: intervalFunc.trim(),
          sfarsit: sfarsit.trim(),
          repaus: repaus.trim(),
          repausSfarsit: repausSfarsit.trim()
        };

        const response = await axios.put(`${API_BASE_URL}/statii-lucru/${editingStatie.id}`, {
          denumire: denumire.trim(),
          intervalFunc: intervalFunc.trim(),
          sfarsit: sfarsit.trim(),
          repaus: repaus.trim(),
          repausSfarsit: repausSfarsit.trim(),
          workingDays,
          ture: existing,
          tura: assignedTura,
          currentUser: currentUser?.username
        });

        setStatiiLucru(statiiLucru.map(s => s.id === editingStatie.id ? response.data : s));
      } else {
        // Add new workstation with the selected tura info
        const tureObj = {};
        tureObj[selectedTura] = {
          intervalFunc: intervalFunc.trim(),
          sfarsit: sfarsit.trim(),
          repaus: repaus.trim(),
          repausSfarsit: repausSfarsit.trim()
        };

        const response = await axios.post(`${API_BASE_URL}/statii-lucru`, {
          denumire: denumire.trim(),
          intervalFunc: intervalFunc.trim(),
          sfarsit: sfarsit.trim(),
          repaus: repaus.trim(),
          repausSfarsit: repausSfarsit.trim(),
          workingDays,
          ture: tureObj,
          tura: assignedTura,
          createdBy: currentUser?.username
        });

        setStatiiLucru([...statiiLucru, response.data]);
      }

      setShowModal(false);
      setDenumire('');
      setIntervalFunc('');
      setSfarsit('');
      setRepaus('');
      setRepausSfarsit('');
      setEditingStatie(null);
      setWorkingDays([]);
    } catch (error) {
      console.error('Error saving statie:', error);
      setError(error.response?.data?.error || 'Eroare la salvarea stației de lucru');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    setDenumire('');
    setIntervalFunc('');
    setSfarsit('');
    setRepaus('');
    setRepausSfarsit('');
    setEditingStatie(null);
    setWorkingDays([]);
    setError('');
  };

  const canUserEdit = () => {
    return !isOperator;
  };

  const openRenameModal = (oldName) => {
    setRenameOldName(oldName);
    setRenameNewName(oldName);
    // try to get existing color from ture list
    const item = (ture || []).find(t => (t.name || t) === oldName);
    setRenameColor(item ? (item.color || '') : '');
    setRenameModalOpen(true);
  };

  const handleConfirmRename = async () => {
    const newName = renameNewName && renameNewName.trim();
    if (!newName) { setError('Numele turei nu poate fi gol'); return; }
    try {
      setLoading(true);
      await axios.put(`${API_BASE_URL}/ture/${encodeURIComponent(renameOldName)}`, { name: newName, color: renameColor });
      await fetchTure();
      await fetchStatiiLucru();
      setRenameModalOpen(false);
      setError('Tura redenumită cu succes');
    } catch (err) {
      console.error('Error renaming tura (modal):', err);
      setError(err.response?.data?.error || 'Eroare la redenumirea turei');
    } finally { setLoading(false); }
  };

  return (
    <div>
      <div className="ture-card" style={{ marginBottom: '1rem' }}>
        <div className="ture-card-header">
          <strong>Ture</strong>
          <div style={{ display:'flex', gap:'0.5rem', alignItems:'center' }}>
            <input type="text" value={newTuraName} onChange={e=>setNewTuraName(e.target.value)} placeholder="Nume tură" />
            <input type="color" value={newTuraColor||'#ffffff'} onChange={e=>setNewTuraColor(e.target.value)} title="Alege culoare" style={{ width:'40px', height:'32px', padding:0, border:'none' }} />
            <button className="btn btn-sm" onClick={handleAddTura} disabled={loading}>Adaugă</button>
          </div>
        </div>

        <div style={{ marginTop:'0.5rem' }}>
          <table style={{ width:'100%' }}>
            <thead>
              <tr><th>Nume</th><th>Culoare</th><th>Acțiuni</th></tr>
            </thead>
            <tbody>
              {ture.map(t => {
                const name = t.name || t;
                const color = t.color || (typeof t === 'string' ? null : t.color);
                return (
                  <tr key={name}>
                    <td>{name}</td>
                    <td style={{ width: '70px' }}><div style={{ width: '24px', height: '16px', background: color || '#fff', border: '1px solid #ccc' }} /></td>
                    <td>
                      <button className="btn btn-sm btn-outline" onClick={() => handleDeleteTura(name)} disabled={loading}>Șterge</button>
                      <button className="btn btn-sm btn-outline" onClick={() => openRenameModal(name)} disabled={loading}>Redenumește</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      
      <div className="card">
        <div className="statii-header" style={{ marginBottom: '1rem' }}>
          <h2><span className="icon-wrench" aria-hidden>🔧</span> Stații de lucru</h2>
          <div className="statii-controls">
            {/* Always show Add button */}
            <button 
              className="btn btn-primary btn-sm"
              onClick={handleAddStatie}
              disabled={loading}
            >
              ➕ Adaugă Stație
            </button>
            {/* 'Tura curentă' selector removed as requested */}

            <input
              id="csv-file-input-statii"
              type="file"
              accept=".csv"
              onChange={handleCSVImport}
              style={{ display: 'none' }}
            />

            <button 
              className="btn import"
              onClick={triggerFileInput}
              disabled={loading || importing}
              title="Importă CSV"
            >
              📂 Importă CSV
            </button>

            <button 
              className="btn export"
              onClick={exportToCSV}
              disabled={loading || importing || statiiLucru.length === 0}
              title="Exportă CSV"
            >
              📤 Exportă CSV
            </button>
          </div>
        </div>

        {error && (
          <div style={{ 
            background: error.includes('succes') ? '#d1e7dd' : '#f8d7da', 
            color: error.includes('succes') ? '#0f5132' : '#721c24', 
            padding: '0.75rem', 
            borderRadius: '4px', 
            marginBottom: '1rem',
            border: error.includes('succes') ? '1px solid #badbcc' : '1px solid #f5c6cb'
          }}>
            {error}
          </div>
        )}

        {/* Filter Section */}
        <div style={{ marginBottom: '1rem' }}>
          <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', marginBottom: '0.5rem' }}>
            <input
              type="text"
              value={filters.denumire}
              onChange={(e) => handleFilterChange('denumire', e.target.value)}
              placeholder="Denumire"
              style={{ 
                flex: 1,
                padding: '0.5rem', 
                borderRadius: '4px', 
                border: '1px solid #ced4da',
                fontSize: '0.9rem'
              }}
            />
            <button 
              className="btn btn-outline"
              onClick={() => handleSort('denumire')}
              style={{ 
                padding: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                fontSize: '0.8rem'
              }}
            >
              Denumire {getSortIcon('denumire')}
            </button>
          </div>

          {filters.denumire && (
            <div style={{ 
              background: '#e7f3ff', 
              color: '#0066cc', 
              padding: '0.5rem', 
              borderRadius: '4px', 
              marginBottom: '0.5rem',
              fontSize: '0.9rem',
              border: '1px solid #b3d9ff'
            }}>
              Filtru activ: <strong>"{filters.denumire}"</strong> - 
              <span style={{ marginLeft: '0.5rem' }}>
                {getFilteredAndSortedStatii().length} din {statiiLucru.length} stații de lucru
              </span>
              <button 
                onClick={() => handleFilterChange('denumire', '')}
                style={{ 
                  marginLeft: '0.5rem', 
                  background: 'none', 
                  border: 'none', 
                  color: '#0066cc', 
                  cursor: 'pointer', 
                  textDecoration: 'underline' 
                }}
              >
                Șterge filtru
              </button>
            </div>
          )}
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th>Denumire</th>
                <th>Tură</th>
                <th>Interval Funcționare</th>
                <th>Zile Funcționare</th>
                <th>Interval Repaus</th>
                <th>Creat de</th>
                <th>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              {getPaginatedStatii().map(statie => (
                <tr key={statie.id}>
                  <td>{statie.denumire}</td>
                  <td>{statie.tura || '-'}</td>
                  <td>
                    {(() => {
                      const shiftVal = statie.ture && statie.ture[selectedTura] ? statie.ture[selectedTura] : null;
                      let start = '';
                      let end = '';
                      if (shiftVal === null) {
                        // No shift key present for this station -> fall back to original fields
                        start = statie.intervalFunc || '';
                        end = statie.sfarsit || '';
                      } else {
                        // Shift key exists but may be empty -> treat empty as no data
                        start = shiftVal.intervalFunc || '';
                        end = shiftVal.sfarsit || '';
                      }
                      return (start && end) ? `${start} - ${end}` : '-';
                    })()}
                  </td>
                  <td>{statie.workingDays && statie.workingDays.length ? statie.workingDays.join(', ') : '-'}</td>
                  <td>
                    {statie.repaus && statie.repausSfarsit 
                      ? `${statie.repaus} - ${statie.repausSfarsit}` 
                      : '-'
                    }
                  </td>
                  <td>{statie.createdBy}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button
                        className={`btn ${canUserEdit(statie) ? 'btn-warning' : 'btn-disabled'}`}
                        onClick={() => handleEditStatie(statie)}
                        disabled={!canUserEdit(statie) || loading}
                        style={{ 
                          fontSize: '0.8rem', 
                          padding: '0.25rem 0.5rem',
                          opacity: canUserEdit(statie) ? 1 : 0.5,
                          cursor: canUserEdit(statie) ? 'pointer' : 'not-allowed'
                        }}
                      >
                        ✏️ Editează
                      </button>
                      <button
                        className={`btn ${canUserEdit(statie) ? 'btn-danger' : 'btn-disabled'}`}
                        onClick={() => handleDeleteStatie(statie)}
                        disabled={!canUserEdit(statie) || loading}
                        style={{ 
                          fontSize: '0.8rem', 
                          padding: '0.25rem 0.5rem',
                          background: canUserEdit(statie) ? '#e74c3c' : '#ccc',
                          opacity: canUserEdit(statie) ? 1 : 0.5,
                          cursor: canUserEdit(statie) ? 'pointer' : 'not-allowed'
                        }}
                      >
                        🗑️ Șterge
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {getFilteredAndSortedStatii().length === 0 && statiiLucru.length > 0 && (
          <p style={{ textAlign: 'center', color: '#666', margin: '2rem 0' }}>
            Nu s-au găsit stații de lucru care să corespundă filtrelor aplicate.
          </p>
        )}

        {statiiLucru.length === 0 && (
          <p style={{ textAlign: 'center', color: '#666', margin: '2rem 0' }}>
            Nu există stații de lucru adăugate. Folosiți butonul "Adaugă Stație de lucru" sau funcția "Importă CSV" pentru a adăuga stații de lucru.
          </p>
        )}

        {/* Pagination */}
        {getFilteredAndSortedStatii().length > 0 && (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center', 
            marginTop: '1rem', 
            padding: '1rem 0',
            borderTop: '1px solid #dee2e6'
          }}>
            {/* Items per page selector */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '0.9rem', color: '#666' }}>Stații per pagină:</span>
              <input
                type="number"
                value={inputValue}
                onChange={handleInputChange}
                min="1"
                max="1000"
                style={{ 
                  width: '70px', 
                  padding: '0.25rem', 
                  borderRadius: '3px', 
                  border: '1px solid #ced4da',
                  textAlign: 'center',
                  fontSize: '0.9rem'
                }}
              />
              <span style={{ fontSize: '0.8rem', color: '#666' }}>(1-1000)</span>
              
              {/* Quick buttons for common values */}
              <div style={{ display: 'flex', gap: '0.25rem' }}>
                {[10, 25, 50, 100].map(value => (
                  <button
                    key={value}
                    onClick={() => handleItemsPerPageChange(value)}
                    style={{
                      padding: '0.2rem 0.4rem',
                      border: '1px solid #ced4da',
                      borderRadius: '3px',
                      fontSize: '0.8rem',
                      backgroundColor: itemsPerPage === value ? '#007bff' : 'white',
                      color: itemsPerPage === value ? 'white' : '#007bff',
                      cursor: 'pointer',
                      minWidth: '25px'
                    }}
                  >
                    {value}
                  </button>
                ))}
              </div>
            </div>

            {/* Pagination controls */}
            {getTotalPages() > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <button
                  onClick={() => handlePageChange(1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    opacity: currentPage === 1 ? 0.5 : 1
                  }}
                >
                  ⏮️
                </button>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                    opacity: currentPage === 1 ? 0.5 : 1
                  }}
                >
                  ◀️
                </button>
                <span style={{ fontSize: '0.9rem', padding: '0 0.5rem' }}>
                  {currentPage} din {getTotalPages()}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === getTotalPages()}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === getTotalPages() ? 'not-allowed' : 'pointer',
                    opacity: currentPage === getTotalPages() ? 0.5 : 1
                  }}
                >
                  ▶️
                </button>
                <button
                  onClick={() => handlePageChange(getTotalPages())}
                  disabled={currentPage === getTotalPages()}
                  style={{
                    padding: '0.5rem',
                    border: '1px solid #ced4da',
                    borderRadius: '3px',
                    backgroundColor: 'white',
                    cursor: currentPage === getTotalPages() ? 'not-allowed' : 'pointer',
                    opacity: currentPage === getTotalPages() ? 0.5 : 1
                  }}
                >
                  ⏭️
                </button>
              </div>
            )}

            {/* Page info */}
            <div style={{ fontSize: '0.9rem', color: '#666' }}>
              {getTotalPages() > 1 && `Pagina ${currentPage} din ${getTotalPages()}`}
            </div>
          </div>
        )}
      </div>

      {/* Modal for Add/Edit Workstation */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ 
            padding: '2rem', 
            margin: '2rem',
            maxWidth: '500px',
            borderRadius: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
          }}>
            <h3 style={{ 
              marginBottom: '1.5rem', 
              color: '#333',
              borderBottom: '2px solid #007bff',
              paddingBottom: '0.5rem'
            }}>
              {editingStatie ? 'Editează Stația de lucru' : 'Adaugă Stație de lucru Nouă'}
            </h3>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Denumire *
              </label>
              <input
                type="text"
                value={denumire}
                onChange={(e) => setDenumire(e.target.value)}
                placeholder="Introduceți denumirea stației de lucru"
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ display:'block', marginBottom:'0.5rem', fontWeight:'600', color:'#555' }}>Zile Funcționare</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:'0.5rem' }}>
                {weekDayOptions.map(d => (
                  <label key={d.key} style={{ fontSize:'0.75rem', display:'flex', alignItems:'center', gap:'0.25rem', background:'#f1f3f5', padding:'4px 6px', borderRadius:'4px' }}>
                    <input type="checkbox" checked={workingDays.includes(d.key)} onChange={()=>{
                      setWorkingDays(prev => prev.includes(d.key) ? prev.filter(x=>x!==d.key) : [...prev, d.key]);
                    }} /> {d.label}
                  </label>
                ))}
              </div>
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Interval Funcționare - Start
              </label>
              <input
                type="time"
                value={intervalFunc}
                onChange={(e) => setIntervalFunc(e.target.value)}
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Interval Funcționare - Sfârșit
              </label>
              <input
                type="time"
                value={sfarsit}
                onChange={(e) => setSfarsit(e.target.value)}
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Interval Repaus - Start
              </label>
              <input
                type="time"
                value={repaus}
                onChange={(e) => setRepaus(e.target.value)}
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ 
                display: 'block', 
                marginBottom: '0.5rem', 
                fontWeight: '600',
                color: '#555'
              }}>
                Interval Repaus - Sfârșit
              </label>
              <input
                type="time"
                value={repausSfarsit}
                onChange={(e) => setRepausSfarsit(e.target.value)}
                style={{ 
                  width: '100%',
                  padding: '0.75rem', 
                  borderRadius: '4px', 
                  border: '1px solid #ced4da',
                  fontSize: '1rem',
                  boxSizing: 'border-box'
                }}
                disabled={loading}
              />
            </div>

            <div className="form-group" style={{ marginBottom: '1.5rem' }}>
              <label style={{ display:'block', marginBottom:'0.5rem', fontWeight:'600', color:'#555' }}>Tură</label>
              <select value={assignedTura || ''} onChange={e=>setAssignedTura(e.target.value)} style={{ width:'100%', padding:'0.5rem', borderRadius:'4px', border:'1px solid #ced4da' }}>
                <option value="">-- Nicio tură selectată --</option>
                {ture.map(t => {
                  const name = typeof t === 'string' ? t : (t.name || '');
                  return <option key={name} value={name}>{name}</option>;
                })}
              </select>
            </div>

            {error && (
              <div style={{ 
                background: '#f8d7da', 
                color: '#721c24', 
                padding: '0.75rem', 
                borderRadius: '4px', 
                marginBottom: '1.5rem',
                fontSize: '0.9rem',
                border: '1px solid #f5c6cb'
              }}>
                {error}
              </div>
            )}

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'flex-end',
              marginTop: '2rem'
            }}>
              <button 
                className="btn btn-secondary" 
                onClick={handleCancel}
                disabled={loading}
                style={{
                  padding: '0.75rem 1.5rem',
                  fontSize: '1rem'
                }}
              >
                Anulează
              </button>
              <button 
                className="btn btn-success" 
                onClick={handleSave}
                disabled={loading || !denumire.trim()}
                style={{
                  padding: '0.75rem 1.5rem',
                  fontSize: '1rem'
                }}
              >
                {loading ? 'Se salvează...' : 'Salvează'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Renaming Tura */}
      {renameModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ maxWidth: '420px' }}>
            <h3>Redenumește Tură</h3>
            <div className="form-group">
              <label>Nume nou</label>
              <input type="text" value={renameNewName} onChange={e=>setRenameNewName(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Culoare</label>
              <input type="color" value={renameColor||'#ffffff'} onChange={e=>setRenameColor(e.target.value)} />
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:'0.5rem' }}>
              <button className="btn btn-secondary" onClick={()=>setRenameModalOpen(false)}>Anulează</button>
              <button className="btn btn-success" onClick={handleConfirmRename} disabled={loading}>Confirmă</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StatiiLucru;
